

import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom'; 
import Swal from 'sweetalert2';
import api from '../../../../utils/api';

const DigiLockerCallback = () => {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);

  useEffect(() => {
    digilockerResponse()
  }, []);

  const digilockerResponse = async()=>{
    try{
        const response = await api.post(`advisor/digilockerResponse`,params)
        console.log("response",response);
    }catch(error){
        Swal.fire("Failed" || "KYC process was cancelled", "error");
    }
  }

  return(
    <>
        <p>
            hi
        </p>
    </>
  );
};

export default DigiLockerCallback;
